import React from "react"
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { AccountFinalReimbursementList } from "./AccountFinalReimbursementList";
import { AccountFinalImplantCostEdit } from "./AccountFinalImplantCostEdit";
import { CalculateReimbursementBtn } from "./CalculateReimbursementBtn";
import { Box, Stack, TextField } from "@mui/material";
import { formatNumber } from "@progress/kendo-intl";

function FinalReimbursementEdit(){
    const account = useAppSelector((state) => state.account.account);
    const totalCalcReimbursement = account.transactionHeader?.totalCalcReimbursement;
    
    return <React.Fragment>
        <br/>
        <Stack direction='row' marginBottom='10px' marginLeft='10px' gap={1} alignItems='center'>
            <AccountFinalImplantCostEdit/>
            <TextField 
                label='Total Calc Reimbursement' 
                value={totalCalcReimbursement !== null && totalCalcReimbursement !== undefined 
                    ? formatNumber(totalCalcReimbursement, 'c')
                    : 'Not Calculated'}
                disabled
            />
            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ marginRight: '15px' }}>
                <CalculateReimbursementBtn/>
            </Box>
        </Stack>
    
        <AccountFinalReimbursementList/>
    </React.Fragment>
}
export {FinalReimbursementEdit}